export default "__VITE_ASSET__Cz0CWY1P__"